import { render, staticRenderFns } from "./TimerLabel.vue?vue&type=template&id=55d8fdbe"
import script from "./TimerLabel.vue?vue&type=script&lang=js"
export * from "./TimerLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports